import React, { useEffect, useState } from 'react';
import './../../css/table.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useFormik } from 'formik';
import * as yup from 'yup';
import './inputStyle.css';
import Alert from 'react-bootstrap/Alert';
import InputCustom from '../Auth/InputCustom';
import TextAreaCustom from '../Auth/TextAreaCustom';
import { useParams } from 'react-router-dom';
import { EditorState, convertFromHTML, convertToRaw, ContentState, convertFromRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const MySwal = withReactContent(Swal);

const NewPost = () => {
  const [file, setFile] = useState('');
  const [initialValues, setInitialValues] = useState([]);
  const [editorState, setEditorState] = useState();
  const [content, setContent] = useState();
  const { id } = useParams();

  useEffect(() => {
    axios
      .get(`https://arianaapp.arianaapply.com/api/V1/get-news/${id}`)
      .then((res) => {
        console.log(res);
        setInitialValues(res.data);
        setEditorState();
        setContent(res.data.content)
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const validationSchema = yup.object({
    title: yup.string().required('وارد کردن عنوان الزامیست'),
    content: yup.string().required('وارد کردن متن پست الزامیست'),
  });

  const onSubmit = (state) => {
  
    let formData = new FormData();
    formData.append('id', id);
    formData.append('title', state.title);
    formData.append('content', state.content);
    formData.append('objectKey', file);
    axios
      .post('https://arianaapp.arianaapply.com/panel/edit-news', formData)
      .then((response) => {
        console.log(response);
        MySwal.fire({
          title: 'با موفقیت ثبت شد',
          icon: 'success',
        }).then((result) => {
          if (result) {
            window.location.reload();
          }
        });
      })
      .catch((err) => {
        console.log(err);
        MySwal.fire({
          title: 'دوباره امتحان کنید',
          icon: 'error',
        });
      });
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
    enableReinitialize: true,
  });

  const imageChangeHandler = (e) => {
    setFile(e.target.files[0]);
  };

  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
    let text = editorState.getCurrentContent().getPlainText("\u0001");
    setContent(draftToHtml(convertToRaw(editorState.getCurrentContent())))
    console.log( 'text' , text);
    console.log( 'editorState' , draftToHtml(convertToRaw(editorState.getCurrentContent())))
  }

  return (
    <div className='index'>
      <form onSubmit={formik.handleSubmit}>
        {/* <Alert variant={`primary`}>فرمت عکس ها حتما باید PNG باشد</Alert> */}
        <Alert variant={`primary`}>
          قبل از آپلود عکس حتما آن را با استفاده از وبسایت های آنلاین مانند
          tinypng بهینه کنید
        </Alert>
        <InputCustom
          name='title'
          type='text'
          label='عنوان پست...'
          formikHandler={formik.getFieldProps('title')}
          formikErrors={formik.errors.title && formik.touched.title}
          formikErrorsName={formik.errors.title}
        />
                <div className='editorWrap'>
          <label>محتوای پست:</label>
          <Editor EditorState={editorState} onEditorStateChange={onEditorStateChange} name="editorState" placeholder="  وارد کنید.." defaultEditorState={content} />
        </div>
        {/* <TextAreaCustom
          name='content'
          label='متن پست...'
          formikHandler={formik.getFieldProps('content')}
          formikErrors={formik.errors.content && formik.touched.content}
          formikErrorsName={formik.errors.content}
        /> */}
        {/* <div className={styles.inputWrap}>
          <label className={styles.label}>کشور...</label>
          <select
            name='category'
            className={
              formik.errors.category && formik.touched.category
                ? styles.inputError
                : styles.input
            }
            {...formik.getFieldProps('category')}>
            <option value=''>انتخاب کنید...</option>
            {categories?.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
          {formik.errors.category && formik.touched.category && (
            <p className={styles.errorText}>{formik.errors.category}</p>
          )}
        </div> */}
        <div className='inputBox'>
          <label>عکس</label>
          <img
            className='post-img'
            src={initialValues?.img?.url}
            alt=''
          />
          <input type='file' name='file' onChange={imageChangeHandler} />
        </div>

        <div className='inputBox'>
          <button
            type='submit'
            className={!formik.isValid && !file ? 'btn-gray' : 'btn-success'}
            disabled={!formik.isValid && !file}>
            ثبت
          </button>
        </div>
      </form>
    </div>
  );
};

export default NewPost;
